export const convertParametersToString = (params) => {
    let paramString = "?";
    for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
            paramString += `${key}=${params[key]}&`;
        }
    }
    paramString = paramString.slice(0, -1);
    return paramString;
};